var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"title":_vm.current_track.text}})}
var staticRenderFns = []

export { render, staticRenderFns }